// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2Gd_V","validationTips":"StatementDescriptor_validationTips__3li_r"};